import { render, staticRenderFns } from "./ModalReturnItems.vue?vue&type=template&id=44a43ea4&scoped=true&"
import script from "./ModalReturnItems.vue?vue&type=script&lang=js&"
export * from "./ModalReturnItems.vue?vue&type=script&lang=js&"
import style0 from "./ModalReturnItems.vue?vue&type=style&index=0&id=44a43ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a43ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a43ea4')) {
      api.createRecord('44a43ea4', component.options)
    } else {
      api.reload('44a43ea4', component.options)
    }
    module.hot.accept("./ModalReturnItems.vue?vue&type=template&id=44a43ea4&scoped=true&", function () {
      api.rerender('44a43ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/modals/ModalReturnItems.vue"
export default component.exports